import React, { useState } from "react";
import VirtualAdoption from "../EngageTabs/VirtualAdoption/VirtualAdoption.component";
import Adoption from "./Adoption/Adoption.component";
import Donate from "./Donate/Donate.component";
import CSRGiving from "./CSRGiving/CSRGiving.component";
import GiftMerchandise from "./GiftMerchandise/GiftMerchandise.component";
import DigitalVolunteer from "./DigitalVolunteer/DigitalVolunteer.component";
import OnsiteVolunteer from "./OnsiteVolunteer/OnsiteVolunteer.component";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./EngageTabs.style.css";

const EngageTabs = () => {
  const [tab, setTab] = useState("virtual_adoption");

  return (
    <>
      <section
        id="engageTabs"
        className={`engage-tabs py-3 px-2 ${
          tab === "virtual_adoption" ? "engage-tabs-v-adoption" : ""
        }`}
      >
        <div
          className={`row ${tab === "virtual_adoption" ? "tabs-row" : ""} ${
            tab === "adoption" ? "tabs-row" : ""
          }`}
        >
          <div
            className="col-12 col-lg-2 abcd"
            style={{ display: window.innerWidth < 1000 ? "flex" : "none" }}
          >
            <div
              className="nav engage-nav scrollbar-hide flex-column nav-pills w-100"
              id="w-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <Swiper slidesPerView={"auto"}>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "virtual_adoption" ? "active" : ""
                    }`}
                    id="v-pills-adopt-tab"
                    data-toggle="pill"
                    onClick={() => setTab("virtual_adoption")}
                    role="tab"
                    aria-controls="v-pills-adopt"
                    aria-selected="true"
                  >
                    Virtual Adoption
                  </a>
                </SwiperSlide>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "adoption" ? "active" : ""
                    }`}
                    id="v-pills-adopt-adopt-tab"
                    data-toggle="pill"
                    onClick={() => setTab("adoption")}
                    role="tab"
                    aria-controls="v-pills-adopt-adopt"
                    aria-selected="true"
                  >
                    Adoption
                  </a>
                </SwiperSlide>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "donate" ? "active" : ""
                    }`}
                    id="v-pills-donate-tab"
                    data-toggle="pill"
                    onClick={() => setTab("donate")}
                    role="tab"
                    aria-controls="v-pills-donate"
                    aria-selected="true"
                  >
                    Donate{" "}
                    <i
                      className="fa fa-heart ml-1"
                      style={{ color: "rgb(126, 3, 71)" }}
                    ></i>
                  </a>
                </SwiperSlide>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "csr_giving" ? "active" : ""
                    }`}
                    id="v-pills-csr-tab"
                    data-toggle="pill"
                    onClick={() => setTab("csr_giving")}
                    role="tab"
                    aria-controls="v-pills-csr"
                    aria-selected="false"
                  >
                    CSR Giving
                  </a>
                </SwiperSlide>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "gift_merchandise" ? "active" : ""
                    }`}
                    id="v-pills-gift-tab"
                    data-toggle="pill"
                    onClick={() => setTab("gift_merchandise")}
                    role="tab"
                    aria-controls="v-pills-gift"
                    aria-selected="false"
                  >
                    Gift Merchandise
                  </a>
                </SwiperSlide>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "digital_volunteer" ? "active" : ""
                    }`}
                    id="v-pills-digital-tab"
                    data-toggle="pill"
                    onClick={() => setTab("digital_volunteer")}
                    role="tab"
                    aria-controls="v-pills-digital"
                    aria-selected="false"
                  >
                    Digital Volunteer
                  </a>
                </SwiperSlide>
                <SwiperSlide>
                  <a
                    className={`nav-link my-lg-2 ${
                      tab === "onsite_volunteer" ? "active" : ""
                    }`}
                    id="v-pills-onsite-tab"
                    data-toggle="pill"
                    onClick={() => setTab("onsite_volunteer")}
                    role="tab"
                    aria-controls="v-pills-onsite"
                    aria-selected="false"
                  >
                    Onsite Volunteer
                  </a>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div
            className="col-12 col-lg-2 abcd"
            style={{ display: window.innerWidth < 1000 ? "none" : "flex" }}
          >
            <div
              className="nav engage-nav scrollbar-hide flex-column nav-pills w-100"
              id="w-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                className={`nav-link my-lg-2 ${
                  tab === "virtual_adoption" ? "active" : ""
                }`}
                id="v-pills-adopt-tab"
                data-toggle="pill"
                onClick={() => setTab("virtual_adoption")}
                role="tab"
                aria-controls="v-pills-adopt"
                aria-selected="true"
              >
                Virtual Adoption
              </a>
              <a
                className={`nav-link my-lg-2 ${
                  tab === "adoption" ? "active" : ""
                }`}
                id="v-pills-adopt-adopt-tab"
                data-toggle="pill"
                onClick={() => setTab("adoption")}
                role="tab"
                aria-controls="v-pills-adopt-adopt"
                aria-selected="true"
              >
                Adoption
              </a>
              <a
                className={`nav-link my-lg-2 ${
                  tab === "donate" ? "active" : ""
                }`}
                id="v-pills-donate-tab"
                data-toggle="pill"
                onClick={() => setTab("donate")}
                role="tab"
                aria-controls="v-pills-donate"
                aria-selected="true"
              >
                Donate <i className="fa fa-heart ml-1"></i>
              </a>
              <a
                className={`nav-link my-lg-2 ${
                  tab === "csr_giving" ? "active" : ""
                }`}
                id="v-pills-csr-tab"
                data-toggle="pill"
                onClick={() => setTab("csr_giving")}
                role="tab"
                aria-controls="v-pills-csr"
                aria-selected="false"
              >
                CSR Giving
              </a>
              <a
                className={`nav-link my-lg-2 ${
                  tab === "gift_merchandise" ? "active" : ""
                }`}
                id="v-pills-gift-tab"
                data-toggle="pill"
                onClick={() => setTab("gift_merchandise")}
                role="tab"
                aria-controls="v-pills-gift"
                aria-selected="false"
              >
                Gift Merchandise
              </a>
              <a
                className={`nav-link my-lg-2 ${
                  tab === "digital_volunteer" ? "active" : ""
                }`}
                id="v-pills-digital-tab"
                data-toggle="pill"
                onClick={() => setTab("digital_volunteer")}
                role="tab"
                aria-controls="v-pills-digital"
                aria-selected="false"
              >
                Digital Volunteer
              </a>
              <a
                className={`nav-link my-lg-2 ${
                  tab === "onsite_volunteer" ? "active" : ""
                }`}
                id="v-pills-onsite-tab"
                data-toggle="pill"
                onClick={() => setTab("onsite_volunteer")}
                role="tab"
                aria-controls="v-pills-onsite"
                aria-selected="false"
              >
                Onsite Volunteer
              </a>
            </div>
          </div>

          <div
            className={`col-12 col-lg-10 pb-md-3 pt-md-3 pt-lg-1 pb-10px padding-top-engage pt-10px ${
              tab === "virtual_adoption" ? "v-adoption-calc-h" : ""
            } ${tab === "adoption" ? "v-adoption-calc-h" : ""} ${
              tab === "csr_giving" ? "" : "padding-right-0"
            }`}
          >
            <div
              className={`tab-content csr_giving ${
                tab === "virtual_adoption" ? "h-100" : ""
              } ${tab === "virtual_adoption" ? "h-100" : ""}`}
              id="v-pills-tabContent"
            >
              <SelectedTab tab={tab} setTab={setTab} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EngageTabs;

const SelectedTab = ({ tab, setTab }) => {
  switch (tab) {
    case "virtual_adoption":
      return <VirtualAdoption setTab={setTab} />;
    case "adoption":
      return <Adoption />;
    case "donate":
      return <Donate />;
    case "csr_giving":
      return <CSRGiving />;
    case "gift_merchandise":
      return <GiftMerchandise />;
    case "digital_volunteer":
      return <DigitalVolunteer />;
    case "onsite_volunteer":
      return <OnsiteVolunteer />;
    default:
      return <VirtualAdoption />;
  }
};
